import * as swcHelpers from '@swc/helpers';

var _postalCode;
const storeDetailsEvent = ({ interaction , store  })=>({
        event: 'storeDetailsClick',
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction
            },
            store: {
                id: store.globalStoreId,
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode = store.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ''
            }
        }
    })
;
var _postalCode1;
const storeGroupEvent = ({ interaction , store , step , city  })=>({
        event: 'storeGroupClick',
        storeLocator: swcHelpers.objectSpread({
            action: swcHelpers.objectSpread({
                step,
                interaction
            }, city === undefined ? {} : {
                city
            })
        }, store === undefined ? {} : {
            store: {
                id: String(store.globalStoreId),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode1 = store.postalCode) !== null && _postalCode1 !== void 0 ? _postalCode1 : ''
            }
        })
    })
;
var _postalCode2;
const storesLocatorResultEvent = ({ interaction , searchResults , searchPosition , store , preferredStore ,  })=>({
        event: 'storeSearchResults',
        storeLocator: {
            action: swcHelpers.objectSpread({
                step: 'store locator results',
                interaction
            }, searchResults === undefined ? {} : {
                searchResults
            }, searchPosition === undefined ? {} : {
                searchPosition
            }),
            store: {
                id: String(store.globalStoreId),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode2 = store.postalCode) !== null && _postalCode2 !== void 0 ? _postalCode2 : '',
                preferredStore: preferredStore !== null && preferredStore !== void 0 ? preferredStore : false
            }
        }
    })
;
const storeSearchSubmitEvent = ({ interaction , searchResults , location ,  })=>({
        event: 'storeSearchSubmit',
        storeLocator: {
            action: {
                step: 'store locator search',
                interaction,
                location,
                searchResults
            }
        }
    })
;
const storesSearchFilterEvent = ({ activeFilters , searchResults  })=>({
        event: 'storeSearchFilter',
        storeLocator: {
            action: {
                step: 'store filter',
                interaction: 'filter click',
                filterName: activeFilters.join(', '),
                searchResults: searchResults !== null && searchResults !== void 0 ? searchResults : null
            }
        }
    })
;

export { storeDetailsEvent, storeGroupEvent, storeSearchSubmitEvent, storesLocatorResultEvent, storesSearchFilterEvent };
//# sourceMappingURL=actions.js.map
